import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import linkstate from 'linkstate';

import DragNDrop from './dragNdrop';
import DragNDropFileupload from './dragNdropFileupload';

import util from '../../lib/util';
import style from './style.css';

@observer
class Handle extends Component {
    render() {
        return <button class='btn btn-link' {...this.props}>
            <i class='fas fa-bars' />
        </button>;
    }
}

@observer
class Item extends Component {
    imageServer = util.getImageServer();

    uniqId = util.randomPassword();

    selectAndCopy = (event) => {
        event.target.select();
        document.execCommand('copy');
        this.setState({ selected: true });
        this.removeSelectText();
    }

    removeSelectText() {
        this.selectTimer = setTimeout(() => {
            this.setState({ selected: false });
        }, 2000);
    }

    handleImageErrored = (e) => {
        const image = e.target;
        image.onerror = null;
        setTimeout(() => {
            image.src += `?${new Date()}`;
        }, 1000);
    }

    render() {
        const { data, handle, beeingDragged, over, imagePrefix, handleDelImage, articleId, idx, ...props } = this.props;
        const { selected, title = '', text = '', size = '800x' } = this.state;

        // name: Screenshot 2019-02-20 at 14.50.55.jpg
        // encoding: 7bit
        // mimetype: image/jpeg
        // ext: .jpg
        // newFilename: dealerweb-cms-e583e492-8ab0-48c8-9033-2c5083bcfbed.jpg
        // s3Link: http://ffe-web-images-original.s3-website-eu-west-1.amazonaws.comdealerweb-cms-e583e492-8ab0-48c8-9033-2c5083bcfbed.jpg
        // s3ThumbLink: //ffe-web-images-resized.s3-website-eu-west-1.amazonaws.com/80x80/dealerweb-cms-e583e492-8ab0-48c8-9033-2c5083bcfbed.jpg
        // sort: 10
        // idx: 9

        let isImage;
        if (data.mimetype) {
            isImage = data.mimetype.match(/^image/);
        } else {
            isImage = data.ext.match(/(jpg|jpeg|gif|png)/i);
        }

        let imageName = `${imagePrefix || 'product'}_${data.sort}_${data.filename}.${data.ext}`;
        if (data.newFilename) {
            imageName = data.newFilename;
        }

        return (
            <li class={`item ${beeingDragged ? style.dragged : ''} ${over ? style.over : ''} mb-2`} {...props}>
                <div class='row'>
                    <div class='col-1 text-right'>
                        {handle}
                    </div>
                    <div class='col-4'>
                        {isImage && <img class='img-fluid'
                            src={`${this.imageServer}/220x/${imageName}`}
                            ondragstart={e => e.preventDefault()}
                            onError={this.handleImageErrored}
                        />}<br />

                        <div class='row'>
                            <div class='col-3'>
                                <small>Dominant</small><br />
                                {data.color && <div
                                    class='rounded-circle border float-left mr-2 mt-2'
                                    style={`background-color: rgb(${data.color[0]}, ${data.color[1]}, ${data.color[2]}); width: 50px; height: 50px;`}
                                >&nbsp;</div>}
                            </div>
                            <div class='col-7'>
                                <small>Palette</small><br />
                                {data.palette && data.palette.map(col => <div
                                    class='rounded-circle border float-left mt-2'
                                    style={`background-color: rgb(${col[0]}, ${col[1]}, ${col[2]}); width: 20px; height: 20px;`}
                                >&nbsp;</div>)}
                            </div>
                        </div>

                        <small><strong>{title}</strong> {text}</small>
                    </div>
                    <div class='col-7'>
                        <button class='btn btn-sm btn-danger float-right'
                            onClick={() => handleDelImage(idx + 1)}
                        >
                            <i class='fas fa-times' />
                        </button>
                        {imageName}<br />
                        {data && ['name', 'mimetype'].map(key => <li style='line-height: .9em;'>
                            {data[key] && <small class='font-weight-lighter'>
                                {key}: {data[key]}
                            </small>}
                        </li>)}

                        {isImage && <div class='row mb-1'>
                            <div class='col-3'>
                                <input class='form-control form-control-sm' oninput={linkstate(this, 'title')} value={title} placeholder='Enter image title' />
                            </div>
                            <div class='col-9'>
                                <input class='form-control form-control-sm' oninput={linkstate(this, 'text')} value={text} placeholder='Enter image text' />
                            </div>
                            <div class='col-12'>
                                {['80x80', '150x', '220x', '400x', '800x', '1024x', '1280x'].map(toggleSize => (
                                    <div class='form-check form-control-sm form-check-inline'>
                                        <input class='form-check-input' type='radio' name='size' id={`size${toggleSize}${this.uniqId}`} value={`${toggleSize}`} onchange={linkstate(this, 'size', 'target.value')} />
                                        <label class='form-check-label' for={`size${toggleSize}${this.uniqId}`}>
                                            {toggleSize}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>}

                        {isImage && <input class='form-control form-control-sm' value={`![${title}](${this.imageServer}/${size}/${imageName} "${text}")`}
                            onClick={this.selectAndCopy}
                        />}
                        {!isImage && <input class='form-control form-control-sm' value={`[${data.name}](${data.s3Link})`}
                            onClick={this.selectAndCopy}
                        />}
                        {selected && <div class={`valid-feedback`} style='display: block;'>
                            Text copied to clipboard...
                        </div>}
                    </div>
                </div>
            </li>
        );
    }
}

@observer
class Images extends Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
        };
    }

    render() {
        const {
            id,
            updateField,
            handleAddImage,
            handleDelImage,
            name,
            value,
            imagePrefix,
            help,
            object,
        } = this.props;
        const { files } = this.state;
        const items = util.makeArrayOfObject(value);

        return (
            <div class='row'>
                <div class='col-7'>
                    <DragNDrop
                        container={({ children }) => <ul class={style.list}>{children}</ul>}
                        items={items}
                        item={Item}
                        handle={Handle}
                        imagePrefix={imagePrefix}
                        onSort={(newItems) => {
                            const obj = object;
                            updateField(id, name, util.makeObjectOfArray(newItems), obj);
                        }}
                        articleId={id}
                        handleDelImage={handleDelImage}
                    />
                </div>
                <div class='col-5'>
                    Upload files or drop them here:<br />
                    <DragNDropFileupload
                        handleAddImage={handleAddImage}
                        apiUrl={'/api/fileupload'}
                    >
                        <div style={{ height: 300, width: 250 }}>
                            {/* {files.map((file, idx) => (
                                <div key={idx}>
                                    {file.name}
                                    Total: {util.asString(file, 'load', 'total')}
                                    <img style='width: 48px;'
                                        alt='Preview'
                                        key={file.preview}
                                        src={file.src}
                                    />
                                </div>
                            ))} */}
                        </div>
                    </DragNDropFileupload>
                </div>
                <small id={`${name}Help`} class='form-text text-muted'>
                    <small class='float-right text-info ml-2'>"{util.getType(value)}"</small>
                    <small class='float-right'>"{name}"</small>
                    {help}
                </small>
            </div>
        );
    }
}

export default Images;



// WEBPACK FOOTER //
// ./components/form/images.js